// Generic [data-api-form] submit (reviews, Q&A, alerts, bookings) + slot picker
// for forms outside checkout + "see reviews" jump.
import { $, $$, api, esc, t } from "./util";

function slotsIn(form) {
	const box = $("[data-slots]", form), input = $("[data-slot-input]", form);
	if (!box || form.matches("[data-checkout-form]")) return;
	api("darat.storefront.api.pickup_slots").then((slots) => {
		const days = [...new Set(slots.map((s) => s.date))], ar = document.documentElement.lang.startsWith("ar");
		box.innerHTML = days.map((d) => {
			const ss = slots.filter((s) => s.date === d);
			const label = ss[0].is_today ? t("اليوم", "Today") : new Date(d + "T12:00").toLocaleDateString(document.documentElement.lang, { weekday: "short", day: "numeric", month: "short" });
			return `<div class="ds-slotday"><b>${esc(label)}</b>${ss.map((s) => `<button type="button" class="ds-slot" data-slot="${esc(s.value)}">${esc(ar ? s.window_ar : s.window)}</button>`).join("")}</div>`;
		}).join("");
		const first = $("[data-slot]", box); if (first) { first.classList.add("is-on"); input.value = first.dataset.slot; }
		box.addEventListener("click", (e) => { const b = e.target.closest("[data-slot]"); if (!b) return; $$("[data-slot]", box).forEach((x) => x.classList.toggle("is-on", x === b)); input.value = b.dataset.slot; });
	}).catch(() => {});
}

export function initTrust() {
	$$("[data-api-form]").forEach((form) => {
		slotsIn(form);
		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			const data = Object.fromEntries(new FormData(form).entries());
			const args = form.dataset.wrap ? { [form.dataset.wrap]: data } : data;
			const btn = $("button[type=submit]", form), err = $("[data-err]", form);
			if (err) err.hidden = true;
			btn.disabled = true;
			try {
				await api(form.dataset.apiForm, args, "POST");
				$$("input:not([type=hidden]):not([type=radio]), textarea, .ds-coupon__row, .ds-starpick, .ds-svcpick, .ds-slots, button[type=submit]", form).forEach((x) => (x.hidden = true));
				$("[data-ok]", form).hidden = false;
			} catch (ex) {
				if (err) { err.textContent = ex.message; err.hidden = false; } else alert(ex.message);
				btn.disabled = false;
			}
		});
	});
	document.addEventListener("click", (e) => {
		const a = e.target.closest("[data-open-tab]"); if (!a) return;
		const tab = $(`[data-tab="${a.dataset.openTab}"]`); if (tab) { tab.click(); tab.scrollIntoView({ behavior: "smooth", block: "center" }); }
	});
}
